var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5743 20.403C8.36974 20.403 9.83269 19.0195 9.83269 17.3217C9.83269 15.6238 8.36974 14.2404 6.5743 14.2404C4.77887 14.2404 3.31592 15.6238 3.31592 17.3217C3.31592 19.0195 4.77887 20.403 6.5743 20.403ZM6.5743 15.9225C7.3889 15.9225 8.05388 16.5514 8.05388 17.3217C8.05388 18.092 7.3889 18.7208 6.5743 18.7208C5.75971 18.7208 5.09473 18.092 5.09473 17.3217C5.09473 16.5514 5.75971 15.9225 6.5743 15.9225Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6843 6.66184C20.6843 4.96399 19.2213 3.58057 17.4259 3.58057C15.6304 3.58057 14.1675 4.96399 14.1675 6.66184C14.1675 8.35968 15.6304 9.74311 17.4259 9.74311C19.2213 9.74311 20.6843 8.35968 20.6843 6.66184ZM15.9463 6.66184C15.9463 5.89152 16.6113 5.26269 17.4259 5.26269C18.2405 5.26269 18.9054 5.89152 18.9054 6.66184C18.9054 7.43215 18.2405 8.06098 17.4259 8.06098C16.6113 8.06098 15.9463 7.43215 15.9463 6.66184Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0724 17.9189L15.3308 21.0001L16.5942 19.8053L14.8487 18.1547H17.7413C19.5367 18.1547 20.9997 16.7712 20.9997 15.0734V11.9921H19.2209V15.0734C19.2209 15.8437 18.5559 16.4725 17.7413 16.4725H14.8487L16.5942 14.8219L15.3308 13.6271L12.0724 16.7084C11.7233 17.0385 11.7233 17.573 12.0724 17.9031V17.9189Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.91101V11.9923H4.77881V8.91101C4.77881 8.14069 5.44379 7.51186 6.25839 7.51186H9.15104L7.40547 9.16254L8.66893 10.3573L11.9273 7.27605C12.2764 6.94591 12.2764 6.41141 11.9273 6.08127L8.66893 3L7.40547 4.19478L9.15104 5.84546H6.25839C4.46295 5.84546 3 7.22889 3 8.92673V8.91101Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.1ac1b5f215a41bc7a20ac14c5c441db1.svg";
export { ForwardRef as ReactComponent };